var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "checkpoint",
      class: { "with-times": _vm.manageTravelTime },
    },
    [
      _c("div", { staticClass: "col-left text-xs flex" }, [
        _vm._m(0),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.checkpoint.delta,
              expression: "checkpoint.delta",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-input delta text-md",
          attrs: { type: "text" },
          domProps: { value: _vm.checkpoint.delta },
          on: {
            blur: [
              _vm.handleModifCheckpointDelta,
              function ($event) {
                return _vm.$forceUpdate()
              },
            ],
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.checkpoint, "delta", _vm._n($event.target.value))
            },
          },
        }),
        _c("span", { staticClass: "text" }, [_vm._v("min)")]),
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.theoricStartAt == null,
              expression: "theoricStartAt == null",
            },
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.checkpoint.travelTimeSinceLast,
              expression: "checkpoint.travelTimeSinceLast",
              modifiers: { number: true },
            },
          ],
          staticClass: "form-input text-md travel-time",
          class: { invalid: _vm.checkpoint.errorTime },
          attrs: { readonly: _vm.fieldIsReadonly(_vm.number), type: "text" },
          domProps: { value: _vm.checkpoint.travelTimeSinceLast },
          on: {
            blur: [
              _vm.handleModifCheckpointSinceLast,
              function ($event) {
                return _vm.$forceUpdate()
              },
            ],
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.checkpoint,
                "travelTimeSinceLast",
                _vm._n($event.target.value)
              )
            },
          },
        }),
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.theoricStartAt != null,
              expression: "theoricStartAt != null",
            },
            {
              name: "inputmask",
              rawName: "v-inputmask",
              value: "99:99",
              expression: "'99:99'",
            },
            {
              name: "model",
              rawName: "v-model.lazy",
              value: _vm.checkpoint.travelHourSinceStart,
              expression: "checkpoint.travelHourSinceStart",
              modifiers: { lazy: true },
            },
          ],
          staticClass: "form-input clock-picker-handler",
          class: { invalid: _vm.checkpoint.errorTime },
          attrs: {
            readonly: _vm.fieldIsReadonly(_vm.number),
            type: "text",
            disabled: _vm.fieldIsReadonly(_vm.number),
          },
          domProps: { value: _vm.checkpoint.travelHourSinceStart },
          on: {
            blur: function ($event) {},
            change: function ($event) {
              return _vm.$set(
                _vm.checkpoint,
                "travelHourSinceStart",
                $event.target.value
              )
            },
          },
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.theoricStartAt != null,
                expression: "theoricStartAt != null",
              },
            ],
            staticClass: "time-with-delta text-gray-500 start",
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.getMinTimeFromDelta(_vm.checkpoint)) +
                "\n        "
            ),
          ]
        ),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.theoricStartAt != null,
                expression: "theoricStartAt != null",
              },
            ],
            staticClass: "time-with-delta text-gray-500 end",
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.getMaxTimeFromDelta(_vm.checkpoint)) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-center" }, [
        _c("div", { staticClass: "number" }, [_vm._v(_vm._s(_vm.number + 1))]),
        _vm._v(" "),
        _c("div", { staticClass: "description" }, [
          _c("i", {
            staticClass: "icon fa-fw",
            class: _vm.iconAP(_vm.checkpoint.type),
          }),
          _c("span", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.checkpoint.name)),
          ]),
          _c("span", {
            staticClass: "path clearfix",
            domProps: {
              innerHTML: _vm._s(_vm.constructPath(_vm.checkpoint.plans)),
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-right flex" }, [
        _c("i", { staticClass: "fa fa-fw fa-arrows-v" }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-fw fa-pencil",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleEditCheckpoint(_vm.number)
            },
          },
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-fw fa-trash",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.handleDeleteCheckpoint(_vm.number)
            },
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text" }, [
      _vm._v("(\n            "),
      _c("span", { staticClass: "more-less-symbol" }, [
        _c("span", { staticClass: "more" }, [_vm._v("+")]),
        _c("span", { staticClass: "sep" }, [_vm._v("/")]),
        _c("span", { staticClass: "less" }, [_vm._v("-")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }